import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard-skeleton',
  templateUrl: './dashboard-skeleton.component.html',
  styleUrls: ['./dashboard-skeleton.component.scss']
})
export class DashboardSkeletonComponent {}
